"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const InputString = ({ id, onValueChange = undefined, onValueUpdated = (_e) => {
    /* nothing to do */
}, value = undefined, maxLength = 255, disabled = false, autocompleteChoices = [], type = 'text', pattern = undefined, min = undefined, max = undefined }) => {
    const actualValue = value === undefined || value === null ? '' : value;
    const defaultAttributes = {
        name: id,
        id: id,
        maxLength: maxLength,
        value: actualValue,
        onChange: onValueChange
            ? onValueChange
            : (evt) => {
                onValueUpdated({ value: evt.target.value, valid: evt.target.validity.valid });
            }
    };
    if (disabled === true) {
        defaultAttributes.disabled = true;
    }
    if (pattern) {
        defaultAttributes.pattern = pattern;
    }
    if (type === 'number' && min !== undefined) {
        defaultAttributes.min = min;
    }
    if (type === 'number' && max !== undefined) {
        defaultAttributes.max = max;
    }
    if (autocompleteChoices && autocompleteChoices.length > 0) {
        const dataListOptions = [];
        autocompleteChoices.forEach((autocompleteChoice, key) => {
            dataListOptions.push(react_1.default.createElement("option", { key: key }, typeof autocompleteChoice === 'string' ? autocompleteChoice : autocompleteChoice.label));
        });
        const dataListId = `datalist_for_${id}`;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("input", Object.assign({ list: dataListId }, defaultAttributes)),
            react_1.default.createElement("datalist", { id: dataListId }, dataListOptions)));
    }
    return (react_1.default.createElement("input", Object.assign({ type: type, autoComplete: "none", className: "apptr__form-input-string apptr__input apptr__input-string" }, defaultAttributes)));
};
exports.default = InputString;
//# sourceMappingURL=InputString.js.map